<template>
	<div class="services">
		<div class="site-content">
			<div class="page-header" :style="{backgroundImage:`url(${require('../assets/images/subheader-career.jpg')})`}" style="background:no-repeat center center;">
			    <div class="container">
			        <div class="breadc-box no-line">
			            <div class="row">
			                <div class="col-md-12">
			                    <h2 class="page-title">售后服务</h2>
			                    <ul id="breadcrumbs" class="breadcrumbs none-style">
			                        <li><router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link></li>
			                        <li class="active">技术服务</li>
			                    </ul>
			                </div>
			            </div>
			        </div>
			    </div>
			</div>
			<section>
				<div class="container">
					<div class="row flex-row">
						<div class="col-sm-12 col-xs-12">
							<h4 class="text-primary">服务说明</h4>
							<h2>售后服务</h2>
							<br>
							<p><i class="fa fa-play"></i> &nbsp;提供酒店管理系统实施的网络技术、系统实施、培训等技术服务</p>
							<p><i class="fa fa-play"></i> &nbsp;提供7*24小时技术热线服务，建立大客户档案，售前工程师在线提供技术问题咨询和故障诊断</p>
							<p><i class="fa fa-play"></i> &nbsp;提供客服QQ在线服务</p>
							<p><i class="fa fa-play"></i> &nbsp;提供远程维护服务，经用户授权可通过电话或Internet远程登录到用户网络系统进行远程支持、在线诊断和故障排除</p>
							<p><i class="fa fa-play"></i> &nbsp;提供现场技术，售前工程师在用户现场提供产品安装测试等技术支持服务</p>
							<p><i class="fa fa-play"></i> &nbsp;提供高级培训，并协助其为直接客户提供产品安装测试、维修调试、项目设计、工程实施等服务，并在产品服务期内现场支持、免费升级</p>
							<p><i class="fa fa-play"></i> &nbsp;产品永久免费升级（同版本）</p>
						</div>
					</div>
					<div class="industris-space-90 sm-hidden"></div>
			    </div>
			</section>
		</div>
			
	</div>
</template>

<script> 
	export default {
        name: 'services_sale',  
		components: {}
	}

  
</script>

<style>
.fa-play{
	color: #1A94E6
}

</style>



// WEBPACK FOOTER //
// src/pages/services_sale.vue